/**
 * Routes that REQUIRE the local adh agent to be reachable.
 *
 * The SPA is permanently decoupled from the adh agent — see
 * .cursor/rules/spa-and-adh-split.mdc. Most routes (`/tools/*`,
 * `/settings`, `/`, `/static-analysis`) work purely client-side or only
 * talk to the agent for optional features that degrade inline; those
 * routes must remain reachable when adh is offline.
 *
 * The routes listed here are the ones that cannot meaningfully render
 * without a live agent — every page-level data fetch hits `/api/*` and
 * a network failure means a blank / broken UI. For those, ServiceGate
 * redirects to `/settings#device` (the canonical 启动服务 tab) rather
 * than letting the page mount on top of a broken backend.
 *
 * Categories:
 *   - `/devices/*` — every per-device action calls adb/scrcpy/mirror.
 *
 * Static analysis (`/static-analysis/*`) is NOT listed: the page shell
 * can render the report list inline even when adh is down (the
 * components themselves show a "本机服务未运行，无法上传或分析新 APK"
 * banner with a link to /settings#device). Forcing a redirect on the
 * whole route hides perfectly good already-uploaded reports.
 *
 * Adding a new ADH-REQUIRED route?
 *   1. Decide whether the page can degrade gracefully (network tools do
 *      with HelperErrorBanner). Prefer degradation over hard-gating.
 *   2. If it really needs adh, add the prefix here.
 *   3. Update Sidebar.tsx to grey out the entry when adh is offline.
 */

const ADH_REQUIRED_PREFIXES = ['/devices'];

export function isAdhRequiredPath(pathname: string): boolean {
  return ADH_REQUIRED_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );
}

export { ADH_REQUIRED_PREFIXES };
